import { m as o, o as a } from "../chunks/register-Ba9sFUKZ.js";
import * as t from "react";
import { at as e } from "../chunks/table-header-CelQ9JJw.js";
const r = (n) => (o(n, e), a({
  tagName: n ? n + "-" + e.tagName : e.tagName,
  elementClass: e,
  react: t,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  r as default,
  r as reactBeaconTableHeader
};
